﻿import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import definitions from '../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../Style/cssHelpers';

const ClauseInfo = ({heading, possession}) => {
    const hasSingleClause = (typeof possession.clauseText !== 'undefined' && possession.clauseText != null);
    const hasMultiClause = (typeof possession.clauses !== 'undefined' && possession.clauses.length > 0);

    return (
        <ClauseWrapper>
            <Clause>
                <ClauseHeading>
                    {heading}
                </ClauseHeading>

                {hasSingleClause &&
                    <p>
                        {possession.clauseText}
                    </p>
                }

                {hasMultiClause &&
                    possession.clauses.map((clause, i) => (
                        <p key={i}>
                            {clause.fromDate &&
                                <ClauseDate>
                                    <em>Från:</em> {moment(clause.fromDate).format('YYYY-MM-DD')}
                                </ClauseDate>
                            }

                            {clause.toDate &&
                                <ClauseDate>
                                    <em>Till:</em> {moment(clause.toDate).format('YYYY-MM-DD')}
                                </ClauseDate>
                            }

                            {clause.text}
                        </p>
                    ))
                }
            </Clause>
        </ClauseWrapper>
    );
}

const ClauseWrapper = styled.div`
    display: block; 
    width: 100%;

    color: white;
    font-size: 16px; 
    font-family: ${definitions.fonts.main};
`;

const Clause = styled.div`
    position: relative;
    margin-top: 40px; 
    
    margin-left: 50px; 
    width: calc(50% - 50px);

    ${mediaQuery.medium(`
        margin-left: 23px;
        width: calc(100% - 25px); 
    `)}    

    ${mediaQuery.small(`
        margin-left: 0; 
        width: 100%; 
    `)}


    &:before {
        position: absolute;
        left: -30px;
        top: -5px;

        ${mediaQuery.medium(`
            left: 75px; 
            top: -4px; 
        `)}

        ${iconCode.informationIcon()} 
    }

    ${mediaQuery.medium(`
        margin-top: 20px;
    `)}

    ${mediaQuery.small(`
        margin-left: 0;
    `)}

    p {
        border-bottom: 1px solid rgba(255, 255, 255, 0.25); 
        padding-bottom: 15px; 

        &:only-child,&:last-of-type {
            border-bottom: none; 
            padding-bottom: 0;
        }
    }
`;

const ClauseHeading = styled.h4`
    font-weight: bold;
    font-size: 16px;
`;

const ClauseDate = styled.span`
    display: block; 

    &:first-of-type {
        margin-top: 10px; 
    }

    &:last-of-type {
        margin-bottom: 10px; 
    }

    em {
        font-weight: bold; 
        font-style: normal; 
    }
`;

export default ClauseInfo; 